import React from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { CurrencyField, DataTable, Field } from '../../../commons/DataTable';
import { ContAffiliation, H5Styled } from '../../../styled-components';
import { formatDate } from '../../../lib/helpers/formatters';
import TotalRow from './TotalRow';

function SupplierTable({ title, suppliers = [], anchorId, remainedTotal = 0 }) {
  const [t] = useTranslation();
  const totalAdminShare = suppliers.reduce(
    (total, supplier) => total + Number(supplier?.adminShare || 0),
    0
  );

  const renderExtraInvoices = (extraInvoices) => {
    const invoices = Array.isArray(extraInvoices) ? extraInvoices : [];
    if (invoices.length === 0) return '-';
    const seen = new Set();
    const uniqueInvoices = invoices.filter((inv) => {
      const key = `${inv?.number}-${inv?.date}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
    const invoicesByDateDesc = [...uniqueInvoices].sort((invA, invB) => {
      const dateA = invA?.date ? new Date(invA.date).getTime() : NaN;
      const dateB = invB?.date ? new Date(invB.date).getTime() : NaN;
      if (Number.isNaN(dateA) && Number.isNaN(dateB)) return 0;
      if (Number.isNaN(dateA)) return 1;
      if (Number.isNaN(dateB)) return -1;
      return dateB - dateA;
    });
    return (
      <div>
        {invoicesByDateDesc.map((inv, index) => {
          const number = inv?.number || '-';
          const date = inv?.date ? formatDate(inv.date) : '-';
          return (
            <div key={`${number}-${inv?.date || index}`}>
              {number} / {date}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <ContAffiliation id={anchorId}>
      <Row>
        <Col xs="12">
          <H5Styled>{title}</H5Styled>
        </Col>
      </Row>
      <DataTable
        data={suppliers}
        total={suppliers.length}
        offset={0}
        limit={suppliers.length || 1}
        onFilter={() => {}}
        emptyText={t('COMMON:NO_DATA')}
        tableFixed
        bottomRow={
          <TotalRow total={totalAdminShare} remainedTotal={remainedTotal} />
        }
      >
        <Field title="Ragione sociale" source="businessName" />
        <Field title="Email comunicazioni" source="emailCommunication" />
        <Field title="Cellulare" source="cell" />
        <Field
          title="Numero Fatture Extra"
          source="extraInvoices"
          render={renderExtraInvoices}
        />
        <CurrencyField
          title="Quota da Incassare"
          source="adminShare"
          className="txt-table-right"
        />
        <CurrencyField
          title="Quota da Emettere"
          source=""
          className="txt-table-right"
        />
      </DataTable>
    </ContAffiliation>
  );
}

export default SupplierTable;
